[
  {
    "id": 1,
    "title": "account-type-1-title",
    "description": "account-type-1-description"
  },
  {
    "id": 2,
    "title": "account-type-2-title",
    "description": "account-type-2-description"
  }
]
